import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '@auth/services/permission.service';

/**
 * Guard de ruta solo para el rol sh_system_admin. Si el usuario no es system
 * admin, redirige a /home. Defensa en profundidad: la UI ya oculta el acceso,
 * y el gateway nginx lo bloquea en el backend.
 */
export const systemAdminGuard: CanActivateFn = () => {
  const permission = inject(PermissionService);
  const router = inject(Router);

  if (permission.isSystemAdmin()) {
    return true;
  }
  router.navigate(['/home']);
  return false;
};
